/* LULL — the only JavaScript in this theme.
   Everything here is an ENHANCEMENT. The price, the options and the button are already in the
   server-rendered HTML, so if this file never loads the customer still sees the full offer and can
   still buy. No script owns the buy box. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function json(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  /* ---------- money, in the shop's own format ---------- */
  var moneyFormat = (json('ShopMoney', {}) || {}).format || '${{amount}}';
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDec = parts.join('.');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/,/g, ' '));
  }

  /* ---------- which bra sizes each alpha size fits ---------- */
  var SIZE_MAP = {};
  String(json('SizeMap', '') || '').split(String.fromCharCode(10)).forEach(function (row) {
    var bits = row.split('=');
    if (bits.length === 2) SIZE_MAP[bits[0].trim().toUpperCase()] = bits[1].trim();
  });

  /* colour -> its own photo, so each bra's thumbnail can follow its swatch */
  var COLOUR_IMAGES = json('ColourImages', {}) || {};

  var PLAN_ID = String((json('PlanData', {}) || {}).id || '');
  var variants = json('VariantData', []) || [];

  var form = document.getElementById('ProductForm');
  if (form && variants.length) {
    var idInput   = document.getElementById('VariantId');
    var qtyInput  = document.getElementById('PackQty');
    var planInput = document.getElementById('SellingPlan');
    var addBtn    = document.getElementById('AddBtn');
    var addLabel  = document.getElementById('AddLabel');
    var addOff    = document.getElementById('AddOff');
    var errorEl   = document.getElementById('FormError');
    var packLabel = document.getElementById('PackLabel');
    function colourAt(i) { return chosen('opt-color-' + i); }
    /* When the swatches are a picker with no Color variant option behind them (a product with too
       many sizes to afford one), colour must not be part of the variant lookup at all. */
    function colourKey() { return (json('OptionIndex', {}) || {}).color_prop_only ? null : colourAt(1); }
    function colours(packN) {
      var out = [];
      for (var i = 1; i <= packN; i++) out.push(colourAt(i) || colourAt(1));
      return out;
    }
    var sizeVal   = document.getElementById('SizeValue');
    var fitsLine  = document.getElementById('FitsLine');

    function chosen(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    /* Which variant option holds the pack, the colour and the size differs per product - the bra
       is Quantity/Color/Size, the shorts are Color/Size/Quantity, and several products have only
       one of the three. The section works it out by NAME and passes the positions here, so this
       never has to assume option1 is a pack again. 0 means the product has no such option. */
    /* Aug 22 2026: these words are written into the DOM by JS, so the Spanish page needs them
       from the section. Defaults are the English originals. */
    var UI = json('UiText', {}) || {};
    var T = function (k, d) { return UI[k] || d; };
    var OPT = json('OptionIndex', {}) || {};
    function optOf(v, which) {
      var n = Number(OPT[which] || 0);
      if (!n) return null;
      return v['option' + n];
    }
    function find(pack, colour, size) {
      /* Fails CLOSED. If the option index is missing - which happens for a few seconds during a
         deploy - an asked-for option that cannot be checked returns NO match rather than the first
         variant, because the first variant is a sold-out size and that made the page un-buyable
         with no error shown. */
      var want = [['pack', pack], ['color', colour], ['size', size]];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < want.length; k++) {
          var which = want[k][0], value = want[k][1];
          if (value === null) continue;
          if (!Number(OPT[which] || 0)) { ok = false; break; }
          if (String(optOf(v, which)) !== String(value)) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function singlePrice() {
      var s = find('1', colourKey(), chosen('opt-size'));
      return s ? s.price : null;
    }

    /* sold-out and non-existent sizes are DISABLED and struck, never hidden */
    function refreshSizes() {
      var pack = chosen('pack'), colour = colourKey();
      Array.prototype.forEach.call(form.querySelectorAll('input[name="opt-size"]'), function (input) {
        var m = find(pack, colour, input.value);
        input.disabled = !(m && m.available);
      });
    }

    function subAllocation(v) {
      if (!v || !PLAN_ID || !v.selling_plan_allocations) return null;
      for (var i = 0; i < v.selling_plan_allocations.length; i++) {
        if (String(v.selling_plan_allocations[i].selling_plan_id) === PLAN_ID) {
          return v.selling_plan_allocations[i];
        }
      }
      return null;
    }

    function update() {
      var pack = chosen('pack'), size = chosen('opt-size');
      var packN = parseInt(pack, 10); if (isNaN(packN) || packN < 1) packN = 1;
      var colour = colourKey();
      var mode = chosen('buymode') || 'once';

      refreshSizes();
      var v = find(pack, colour, size);

      /* show one colour picker per bra in the chosen pack */
      for (var s = 1; s <= 3; s++) {
        var grp = document.querySelector('.sm__cgroup[data-slot="' + s + '"]');
        if (grp) {
          /* class, not the hidden attribute: an author display rule can beat [hidden] */
          grp.classList.toggle('is-off', s > packN);
          grp.hidden = s > packN;
        }
        var lbl = document.getElementById('ColourValue' + s);
        if (lbl) lbl.textContent = colourAt(s) || '';

        /* repoint this bra's thumbnail at the colour it is set to. srcset has to go, or the
           browser keeps serving the picture it already picked from the old candidate list. */
        if (grp) {
          var timg = grp.querySelector('.sm__cthumbimg');
          var tsrc = COLOUR_IMAGES[colourAt(s) || ''];
          if (timg && tsrc) { timg.removeAttribute('srcset'); timg.src = tsrc; }
        }
      }
      var multi = document.getElementById('ColourGroups');
      if (multi) multi.classList.toggle('is-multi', packN > 1);

      /* keep the hidden properties in step, so a no-JS post still records her choices */
      for (var q = 1; q <= 3; q++) {
        var prop = document.getElementById('PropColour' + q);
        if (prop) prop.value = (q <= packN) ? (colourAt(q) || '') : '';
      }
      if (sizeVal && size) sizeVal.textContent = size;

      if (fitsLine && size) {
        var fits = SIZE_MAP[String(size).toUpperCase()];
        if (fits) {
          /* Sep 3 2026, his instruction: show EVERY bra size the alpha size fits, as a plain list.
             It used to collapse to "<band><first cup> to <band><last cup>" using ONLY the band of
             the FIRST entry. That is right only when a size maps to one band. On a real chart a
             size spans several bands - M is 34D, 34DD/E, 36C, 36D, 38C - so the range printed a
             band that was simply wrong and hid the rest. Print the map verbatim; it is already
             ordered band-then-cup by the template that generates it. */
          fitsLine.textContent = T('fits', 'Fits sizes: ') + fits;
          fitsLine.hidden = false;
        }
        else { fitsLine.hidden = true; }
      }

      if (!v) {
        idInput.value = '';
        addBtn.disabled = true;
        addLabel.textContent = T('unavailable', 'Unavailable');
        if (addOff) addOff.textContent = '';
        return;
      }

      idInput.value = v.id;

      /* ⚠️ THE QUANTITY TRAP: option1 is the pack and the variant price is PER BRA, so the cart
         quantity must equal the pack number or Shopify charges for one bra at the pack's
         discounted per-bra price. */
      /* ⚠️ ALWAYS 1. The variant price is the whole pack, so the pack size must NOT live in the
         cart quantity - that is what let order #3126 buy one bra at the two-pack rate after the
         quantity was edited down in a cart we do not control. */
      qtyInput.value = 1;

      /* subscription: only send selling_plan when subscribe is the chosen mode */
      var alloc = subAllocation(v);
      if (planInput) planInput.value = (mode === 'sub' && alloc) ? PLAN_ID : '';

      var unit = (mode === 'sub' && alloc) ? alloc.price : v.price;

      /* THE PERCENTAGE IS CALCULATED, NEVER TYPED. It comes off Shopify's own allocation for the
         variant she is looking at, so it cannot advertise a discount the checkout will not give. */
      var subHead = form.querySelector('[data-subhead]');
      if (subHead && alloc && v.price > 0) {
        subHead.textContent = (subHead.getAttribute('data-subtitle') || '') + ' ' +
          Math.round((v.price - alloc.price) / v.price * 100) + '%';
      }

      /* THE TICK REPRICES THE CARDS. The row itself carries no price, so the pack cards are the
         only place she reads one - every card has to show the price for the mode she is in, not
         just the tier she happens to have selected. */
      var single = singlePrice();
      var cards = form.querySelectorAll('.sm__pack[data-pack]');
      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var cp = card.getAttribute('data-pack');
        var cn = parseInt(cp, 10); if (isNaN(cn) || cn < 1) cn = 1;
        /* her colour and size first; fall back to any variant of that pack, which is what the
           server-rendered card price already does */
        var cv = find(cp, colourKey(), size) || find(cp, null, null);
        if (!cv) continue;
        var ca = subAllocation(cv);
        var cTotal = (mode === 'sub' && ca) ? ca.price : cv.price;   /* the whole pack */
        var cUnit = Math.round(cTotal / cn);                          /* shown per bra */
        var cWas = (single || cv.price) * cn;
        var cSave = cWas - cTotal;
        var nowEl = card.querySelector('[data-now]');
        var wasEl = card.querySelector('[data-was]');
        var saveEl = card.querySelector('[data-save]');
        if (nowEl) nowEl.innerHTML = money(cUnit) + (cn > 1 ? '<em>' + T('each', '/each') + '</em>' : '');
        if (wasEl) { wasEl.textContent = money(cWas); wasEl.hidden = !(cSave > 0); }
        if (saveEl) {
          if (cSave > 0) {
            saveEl.textContent = 'Save ' + money(cSave);
            saveEl.classList.remove('sm__savepill--none');
          } else {
            saveEl.textContent = saveEl.getAttribute('data-starter') || 'Starter';
            saveEl.classList.add('sm__savepill--none');
          }
        }
      }

      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? T('add', 'Add to cart') : T('soldout', 'Sold out');

      /* The right half of the button used to read "Get n% off". It now carries the MONEY: the
         compare-at total struck through and the real total for whatever is selected, subscription
         included, so the number she taps is the number she is charged. */
      if (addOff) {
        var total = unit;                       /* unit IS the pack total now */
        var cmp = Number(v.compare_at_price || 0);
        var refUnit = (cmp > v.price) ? cmp : (single || v.price);
        var ref = (cmp > v.price) ? cmp : (refUnit * packN);   /* compare_at is per pack; the single-price fallback is per bra */
        addOff.innerHTML = v.available
          ? ((ref > total ? '<s>' + money(ref) + '</s>' : '') + '<b>' + money(total) + '</b>')
          : '';
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);   /* never pushState - it poisons the back button */

      /* the sticky button carries the same discount label as the one in the buy box */
      var so = document.getElementById('StickyOff');
      if (so && addOff) so.innerHTML = addOff.innerHTML;
    }

    form.addEventListener('change', function (e) {
      if (!e.target || !e.target.name) return;
      if (e.target.name === 'pack' || e.target.name === 'buymode' || e.target.name.indexOf('opt-') === 0) {
        if (errorEl) errorEl.textContent = '';
        update();
      }
    });

    /* Paint once on load. Nothing called update() at init, so the subscribe row showed the
       one-time price, the sticky bar was blank, the "get n% off" label was empty and sold-out
       sizes were not struck until she happened to touch a control. */
    update();

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;                 /* the plain POST still works */
      e.preventDefault();
      if (errorEl) errorEl.textContent = '';
      addBtn.disabled = true;

      /* ONE LINE PER PACK. A pack is a single purchase at a single per-bra rate, so it is a single
         line of quantity = the pack size. The colours of the individual bras ride along as line
         item properties, which is the only way a two-colour pack can stay one line: colour is a
         variant option, so two colours would otherwise force two lines - and two lines of quantity
         one is what made a 2-pack read "2 bras" beside a one-bra price and a wrong subtotal. */
      var packNow = parseInt(chosen('pack'), 10) || 1;
      var sizeNow = chosen('opt-size');
      var wanted = colours(packNow);
      var NOUN = (json('ItemNoun', {}) || {}).noun || 'Item';
      var props = {};
      wanted.forEach(function (c, n) { props[NOUN + ' ' + (n + 1)] = c; });
      /* A property whose name starts with an underscore is stored but never shown to her or on the
         order. We keep the full colour list there so stepping 2 -> 1 -> 2 in the cart brings the
         second colour BACK, instead of silently making both bras the first colour. */
      props['_colours'] = wanted.join('|');
      /* The supplier reads the order line, not our pricing history. Before Aug 27 a pack
         posted quantity = the pack size, so a 3-pack read "x3" and the supplier asked whether
         that meant nine bras (order #3089). Since Aug 27 a pack posts quantity 1, which reads
         "x1" and invites the opposite mistake. Neither number is the piece count, so say it. */
      props['_pieces'] = String(wanted.length);

      /* colourKey(), not wanted[0]: when the swatches are a picker with no Color option behind them,
         passing a colour makes find() fail closed, and the fallback line carried NO properties -
         so the order never said which colour each bra was. */
      var v2 = find(String(packNow), colourKey(), sizeNow);
      var items = [];
      if (v2) {
        var line = { id: v2.id, quantity: 1, properties: props };
        if (planInput && planInput.value) line.selling_plan = Number(planInput.value);
        items.push(line);
      }
      if (!items.length) { items = [{ id: Number(idInput.value), quantity: Number(qtyInput.value) || 1 }];
        if (planInput && planInput.value) items[0].selling_plan = Number(planInput.value); }
      var body = { items: items };
      /* ask for the drawer back in the SAME round trip - one request, not two */
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (r) {
          /* fetch does NOT reject on 4xx - this check is mandatory */
          if (!r.ok) {
            if (errorEl) errorEl.textContent = r.d.description || r.d.message || 'Sorry, that could not be added.';
            return;
          }
          /* Shopify MERGES a repeat add of the same variant: two 2-packs become one line of 4,
             but the properties stay as the first add left them, so the line claimed 4 items and
             listed 2 colours. Top the list back up to the line's real quantity. */
          if (r.d.items && r.d.items.length) {
            (function () {
              var added = r.d.items[0];
              var have = String((added.properties || {})['_colours'] || '').split('|').filter(Boolean);
              /* THE TARGET IS PACK SIZE x LINE QUANTITY, NOT THE QUANTITY. Topping up to
                 added.quantity was right only while quantity WAS the bra count. Since Aug 27 a
                 pack posts quantity 1, so two merged 2-packs are quantity 2 and hold FOUR bras -
                 and the old sum listed two colours against a four-bra line. */
              var want2 = packNow * added.quantity;
              if (!have.length || have.length >= want2) return;
              var full = [];
              for (var n = 0; n < want2; n++) full.push(have[n % have.length]);
              var fixed = { '_colours': full.join('|'), '_pieces': String(full.length) };
              for (var m2 = 0; m2 < full.length; m2++) fixed[NOUN + ' ' + (m2 + 1)] = full[m2];
              fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                /* quantity MUST be sent: change.js treats a missing quantity as 1, which wiped
                   the merged line down to a single item. */
                body: JSON.stringify({ id: added.key, quantity: added.quantity, properties: fixed,
                                       sections: 'cart-drawer', sections_url: window.location.pathname })
              })
                .then(function (res) { return res.ok ? res.json() : null; })
                .then(function (d2) {
                  if (d2 && d2.sections && d2.sections['cart-drawer'] && window.LullCart) {
                    window.LullCart.swap(d2.sections['cart-drawer']);
                  }
                })
                .catch(function () {});
            }());
          }
          if (r.d.sections && r.d.sections['cart-drawer'] && window.LullCart) {
            window.LullCart.swap(r.d.sections['cart-drawer']);
            window.LullCart.open();
          } else {
            window.location.href = root + 'cart';   /* fallback, never leave her stranded */
          }
        })
        .catch(function () { if (errorEl) errorEl.textContent = 'Network problem. Please try again.'; })
        .finally(function () { addBtn.disabled = false; });
    });

    /* sticky bar: submits when a size is chosen, otherwise focuses the picker IN PLACE.
       Growth Rock measured that a bar which scrolls the page produced no lift, while one that opens
       the selection where she already is produced +5.2% orders. */
    var barBtn = document.getElementById('StickyBtn');
    var bar = document.getElementById('StickyBar');
    if (barBtn) {
      barBtn.addEventListener('click', function () {
        if (!addBtn.disabled) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
        var first = document.querySelector('#SizeList input:not(:disabled)');
        if (first) first.focus();
      });
    }
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -60px 0px' }).observe(addBtn);
    }

    /* ---------- PRODUCT GALLERY — his spec, Aug 22 2026, permanent on every product page ----------
       One image visible at a time, cross-faded in place. No horizontal scroller, no thumbnails.
       The dots are the only index and they sit inside the photo; a small chevron brackets them on
       each side. A larger pair of naked chevrons sits on the left and right edges and is INVISIBLE
       until she hovers, swipes, scrolls the page or tabs onto one, then fades out after 1.8s.
       Wraps both ways. Badges belong to image 1 and are hidden the moment she leaves it. */
    (function () {
      var stage = document.getElementById('SmGallery');
      if (!stage) return;
      var slides = Array.prototype.slice.call(stage.querySelectorAll('.sm__slide'));
      if (slides.length < 1) return;
      var dots   = Array.prototype.slice.call(stage.querySelectorAll('.sm__dot'));
      var badges = document.getElementById('SmBadges');
      var arrows = Array.prototype.slice.call(stage.querySelectorAll('.sm__edge'));
      var at = 0;

      function show(i) {
        var n = slides.length;
        i = ((i % n) + n) % n;                       /* wrap both directions */
        if (i === at) return;
        slides[at].classList.remove('is-on');
        slides[at].setAttribute('aria-hidden', 'true');
        slides[i].classList.add('is-on');
        slides[i].removeAttribute('aria-hidden');
        if (dots[at]) { dots[at].classList.remove('is-on'); dots[at].setAttribute('aria-selected', 'false'); }
        if (dots[i])  { dots[i].classList.add('is-on');     dots[i].setAttribute('aria-selected', 'true'); }
        at = i;
        /* the badges are a claim about the hero shot, so they only belong on it */
        if (badges) { if (i === 0) badges.removeAttribute('hidden'); else badges.setAttribute('hidden', ''); }
      }

      /* the edge arrows appear on demand and go away again */
      var hideT = null;
      function peek() {
        if (slides.length < 2) return;
        stage.classList.add('is-peek');
        clearTimeout(hideT);
        hideT = setTimeout(function () { stage.classList.remove('is-peek'); }, 1800);
      }
      stage.addEventListener('mouseenter', peek);
      stage.addEventListener('mousemove', peek);
      stage.addEventListener('mouseleave', function () {
        clearTimeout(hideT);
        stage.classList.remove('is-peek');
      });
      arrows.forEach(function (a) {
        a.addEventListener('focus', peek);
        a.addEventListener('blur', function () { hideT = setTimeout(function () { stage.classList.remove('is-peek'); }, 1800); });
      });
      /* page scroll reveals them too, but only while the gallery is actually on screen */
      var onScreen = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }, { threshold: 0.15 }).observe(stage);
      }
      var scrollTick = false;
      window.addEventListener('scroll', function () {
        if (scrollTick || !onScreen) return;
        scrollTick = true;
        setTimeout(function () { scrollTick = false; peek(); }, 200);
      }, { passive: true });

      /* every control: the dots, the two nubs beside them, the two edge arrows */
      stage.addEventListener('click', function (e) {
        var hit = e.target.closest && e.target.closest('[data-go], .sm__dot');
        if (!hit || !stage.contains(hit)) return;
        e.preventDefault();
        peek();
        if (hit.hasAttribute('data-go')) show(at + Number(hit.getAttribute('data-go')));
        else show(Number(hit.getAttribute('data-i')));
      });

      /* keyboard, once a dot or arrow has focus */
      stage.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (!e.target.closest || !e.target.closest('.sm__dot, .sm__edge, .sm__nub')) return;
        e.preventDefault();
        peek();
        show(at + (e.key === 'ArrowRight' ? 1 : -1));
      });

      /* SWIPE. A horizontal drag over 40px moves one image. A mostly-vertical drag is left alone so
         the page still scrolls, which is also why the CSS is touch-action: pan-y pinch-zoom. */
      var x0 = null, y0 = null, decided = false, horiz = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }   /* a pinch is not a swipe */
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
        decided = false; horiz = false;
      }, { passive: true });
      /* Aug 22 2026, his ask: sliding through the images should not drag the whole page up and
         down with it. Two changes. The axis test is BIASED toward horizontal - a drag only counts as
         a page scroll when it is clearly more vertical than horizontal (the 0.62 factor, about 58
         degrees) - and once a swipe is locked horizontal the move is preventDefault'ed, which needs a
         NON-passive listener. A deliberate up or down drag still scrolls normally, so she is never
         trapped on the gallery. */
      stage.addEventListener('touchmove', function (e) {
        if (x0 === null || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (!decided && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          decided = true;
          horiz = Math.abs(dx) > Math.abs(dy) * 0.62;
        }
        if (horiz) {
          peek();
          if (e.cancelable) e.preventDefault();   /* hold the page still while she slides sideways */
        }
      }, { passive: false });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches && e.changedTouches[0];
        if (t && horiz) {
          var dx = t.clientX - x0;
          if (Math.abs(dx) > 40) { show(at + (dx < 0 ? 1 : -1)); peek(); }
        }
        x0 = null;
      }, { passive: true });

      /* mouse drag on desktop, same 40px rule */
      var mx = null;
      stage.addEventListener('mousedown', function (e) { if (e.button === 0) mx = e.clientX; });
      window.addEventListener('mouseup', function (e) {
        if (mx === null) return;
        var dx = e.clientX - mx; mx = null;
        if (Math.abs(dx) > 40) { show(at + (dx < 0 ? 1 : -1)); peek(); }
      });

      show(0);
      if (badges) badges.removeAttribute('hidden');
    }());


    /* ---------- band + cup -> alpha size ----------
       Inverted from SIZE_MAP so there is a single source of truth: "XL = 34A, 34B, 34C, 34D, 34E"
       means band 34 with any of those cups resolves to XL. She picks the two numbers she already
       knows and the size button is chosen for her. */
    (function () {
      var bandSel = document.getElementById('BandSel');
      var cupSel  = document.getElementById('CupSel');
      var out     = document.getElementById('BandCupOut');
      if (!bandSel || !cupSel || !out) return;

      var lookup = {}, bands = [], cups = [];
      Object.keys(SIZE_MAP).forEach(function (alpha) {
        SIZE_MAP[alpha].split(',').forEach(function (raw) {
          var t = raw.trim().toUpperCase();
          var m = t.match(/^(\d+)\s*([A-Z]+(?:\/[A-Z]+)?)$/);
          if (!m) return;
          var band = m[1], cup = m[2];
          lookup[band + '|' + cup] = alpha;
          if (bands.indexOf(band) === -1) bands.push(band);
          if (cups.indexOf(cup) === -1) cups.push(cup);
        });
      });
      if (!bands.length) return;

      bands.sort(function (a, b) { return a - b; });
      bands.forEach(function (b) {
        var o = document.createElement('option'); o.value = b; o.textContent = b; bandSel.appendChild(o);
      });
      cups.forEach(function (c) {
        var o = document.createElement('option'); o.value = c; o.textContent = c; cupSel.appendChild(o);
      });

      function resolve() {
        var b = bandSel.value, c = cupSel.value;
        if (!b || !c) {
          out.textContent = 'Size';
          /* leaving the size radio selected from a previous answer contradicted the readout */
          var prev = document.querySelector('#SizeList input:checked');
          if (prev) { prev.checked = false; prev.dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
        var alpha = lookup[b + '|' + c];
        if (!alpha) { out.textContent = 'Not made'; return; }
        out.textContent = alpha;
        var radio = document.querySelector('#SizeList input[value="' + alpha + '"]');
        if (radio && !radio.disabled) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      bandSel.addEventListener('change', resolve);
      cupSel.addEventListener('change', resolve);
    }());

    /* ---------- the "Size and Fit Guide" link ----------
       Which guide exists depends on the product: a bra has the band-and-cup matrix, a top has a
       plain measurement table. The link opens whichever one is on the page and scrolls to it, so
       it never needs to know what it is looking at. */
    (function () {
      var link = document.getElementById('OpenSizeGuide2');
      if (!link) return;
      link.addEventListener('click', function () {
        var box = document.getElementById('SizeGuide') || document.getElementById('SizeTable');
        if (!box) return;
        box.open = true;
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }());
  }

  window.LullCart = (function () {
    function el() { return document.getElementById('CartDrawer'); }

    function open() {
      var d = el();
      if (!d) return;
      if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
      else { d.setAttribute('open', ''); }
      document.body.style.overflow = 'hidden';
    }

    function close() {
      var d = el();
      if (!d) return;
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
      document.body.style.overflow = '';
    }

    function swap(html) {
      var current = el();
      if (!current) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById('CartDrawer');
      if (fresh) { current.innerHTML = fresh.innerHTML; wire(); }
      count();
    }

    /* The header badge never updated, because the drawer markup does not contain it.
       Read the real cart instead, and create the badge when it does not exist yet. */
    function count() {
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var bag = document.getElementById('BagLink');
          if (!bag) return;
          var b = bag.querySelector('.hd__count');
          if (c.item_count > 0) {
            if (!b) { b = document.createElement('span'); b.className = 'hd__count'; bag.appendChild(b); }
            b.textContent = c.item_count;
          } else if (b) {
            b.remove();
          }
          bag.setAttribute('aria-label', 'Bag, ' + c.item_count + ' items');
        })
        .catch(function () {});
    }

    function wire() {
      var x = document.getElementById('CartClose');
      if (x) x.addEventListener('click', close);


    }

    /* ---------- the cart line stepper: ONE delegated listener, bound once ----------
       Changing how many bras changes WHICH PACK RATE she is on, so every step swaps the variant:
       1 bra buys the 1-pack, 2 the 2-pack, 3 or more the 3-pack. A plain quantity change would
       have sold one bra at the 3-pack rate. Stepping below one empties the line.

       Remove-then-add is two requests and is not atomic, so: one lock per LINE, the remove is
       checked before the add is sent, and any failure reloads rather than leaving her short. */
    var swapping = {};

    function sectionsWanted() {
      var out = { names: 'cart-drawer', id: null, host: null };
      var ct = document.querySelector('[id^="shopify-section-"] .ct__line');
      if (ct) {
        out.host = ct.closest('[id^="shopify-section-"]');
        out.id = out.host.id.replace('shopify-section-', '');
        out.names += ',' + out.id;
      }
      return out;
    }

    function applySections(d, want) {
      var sec = d.sections || {};
      if (sec['cart-drawer']) swap(sec['cart-drawer']);
      /* the cart PAGE has to be re-rendered too, or she is charged a price the page never shows */
      if (want.id && sec[want.id] && want.host) {
        var tmp = document.createElement('div');
        tmp.innerHTML = sec[want.id];
        var fresh = tmp.querySelector('[id^="shopify-section-"]') || tmp.firstElementChild;
        if (fresh) want.host.innerHTML = fresh.innerHTML;
      }
      if (window.LullCart && window.LullCart.count) window.LullCart.count();
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.js-lineqty');
      if (!btn) return;
      e.preventDefault();

      var box = btn.closest('.lc');
      if (!box) return;
      var key = box.dataset.key;
      if (swapping[key]) return;

      var to = Number(btn.dataset.to);
      var want = sectionsWanted();
      box.classList.add('is-busy');   /* both buttons, on every path, until the swap lands */

      /* down to nothing: just take the line out */
      if (to < 1) {
        swapping[key] = true;
        fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0, sections: want.names, sections_url: window.location.pathname })
        })
          .then(function (res) { if (!res.ok) throw new Error('remove failed'); return res.json(); })
          .then(function (d) { applySections(d, want); })
          .catch(function () { window.location.reload(); })
          .finally(function () { swapping[key] = false; });
        return;
      }

      /* A product with no pack tiers (the brief, the sleep mask) has no variant to swap TO, so it
         just changes quantity on the line it already has. Without this branch the handler bailed on
         the missing data-v2 and the stepper did nothing at all - and there is no other remove
         control, so the line could not be taken out of the cart. */
      if (!box.dataset.v1 && !box.dataset.v2 && !box.dataset.v3) {
        swapping[key] = true;
        fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: to, sections: want.names, sections_url: window.location.pathname })
        })
          .then(function (res) { if (!res.ok) throw new Error('change failed'); return res.json(); })
          .then(function (d) { applySections(d, want); })
          .catch(function () { window.location.reload(); })
          .finally(function () { swapping[key] = false; });
        return;
      }

      /* the best rate we sell is the 3-pack, so the stepper stops there */
      var tier = to > 3 ? 3 : to;
      var vid = Number(box.dataset['v' + tier] || 0);
      if (!vid) { box.classList.remove('is-busy'); return; }

      /* ⚠️ QUANTITY 1, ALWAYS. On a pack-priced line the variant already carries the whole
         pack, so posting the bra count here would charge that many PACKS. */
      var qty = (box.dataset.mode === 'pack') ? 1 : to;
      var line = { id: vid, quantity: qty };
      if (box.dataset.plan) line.selling_plan = Number(box.dataset.plan);

      /* carry the per-bra colours: new bras inherit the first one, removed bras go */
      var kept = {};
      try { kept = JSON.parse(box.dataset.props || '{}'); } catch (err) { kept = {}; }

      /* the remembered list is the source of truth; the visible Bra N props are derived from it */
      var remembered = String(kept['_colours'] || '').split('|').filter(Boolean);
      var first = remembered[0] || '';
      if (first) {
        /* grow the memory when she asks for more bras than she has ever chosen colours for */
        while (remembered.length < to) remembered.push(first);
        var NOUN2 = (json('ItemNoun', {}) || {}).noun || 'Item';
        var props = {};
        for (var n = 1; n <= to; n++) props[NOUN2 + ' ' + n] = remembered[n - 1] || first;
        props['_colours'] = remembered.slice(0, to).join('|');
        /* the same piece count, kept equal to the colour slots so the order can never show a
           count that disagrees with the colours listed beside it */
        props['_pieces'] = String(to);
        line.properties = props;
      }

      swapping[key] = true;
      box.classList.add('is-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (res) {
          /* fetch does not reject on 4xx. Adding after a failed remove is what duplicated lines. */
          if (!res.ok) throw new Error('remove failed');
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [line], sections: want.names, sections_url: window.location.pathname })
          });
        })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function (d) { applySections(d, want); })
        .catch(function () { window.location.reload(); })
        .finally(function () { swapping[key] = false; });
    });

    document.addEventListener('click', function (e) {
      var d = el();
      if (d && e.target === d) close();          /* click the backdrop to dismiss */
    });

    /* Escape closes the dialog natively, which never ran our handler, so the page stayed
       scroll-locked. Listen to the dialog's own close event instead. */
    var dlg = el();
    if (dlg) dlg.addEventListener('close', function () { document.body.style.overflow = ''; });

    /* the bag icon opens the drawer rather than leaving the page */
    var bagLink = document.getElementById('BagLink');
    if (bagLink && el()) {
      bagLink.addEventListener('click', function (e) {
        e.preventDefault();
        fetch(root + '?section_id=cart-drawer')
          .then(function (r) { return r.text(); })
          .then(function (html) { swap(html); open(); })
          .catch(function () { window.location.href = root + 'cart'; });
      });
    }

    wire();
    return { open: open, close: close, swap: swap, count: count };
  }());

  /* ---------- reviews: four at a time, filterable by age and cup ----------
     Two independent reasons a review can be hidden, so they get two separate classes.
     is-more = further down the list than she has asked to see.
     is-out  = filtered out. Filtering always reveals every match, otherwise choosing
     "65 and over" could show nothing while matching reviews sat behind the button. */
  var reviews = document.querySelectorAll('.review');
  var moreBtn = document.getElementById('ReviewMore');
  var rvFilters = document.getElementById('ReviewFilters');

  var STEP = 6;
  var revealed = STEP;   /* how many she has asked to see, kept so a filter can be undone */

  function applyReveal() {
    Array.prototype.forEach.call(reviews, function (r, i) {
      r.classList.toggle('is-more', i >= revealed);
    });
    if (moreBtn) moreBtn.hidden = revealed >= reviews.length;
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      revealed = Math.min(revealed + STEP, reviews.length);
      applyReveal();
    });
  }

  if (rvFilters) {
    rvFilters.addEventListener('change', function () {
      function val(n) { var e = rvFilters.querySelector('[name="' + n + '"]'); return e ? e.value : ''; }
      var a = val('f-age'), c = val('f-cup');
      var filtering = a !== '' || c !== '';
      var matches = 0;
      Array.prototype.forEach.call(reviews, function (r) {
        var ok = (!a || r.dataset.age === a) && (!c || r.dataset.cup === c);
        r.classList.toggle('is-out', !ok);
        if (ok) matches++;
        /* while filtering, every match is shown; when the filter clears, the previous
           "show six more" position is restored rather than leaving all 69 open */
        if (filtering) r.classList.remove('is-more');
      });
      if (filtering) {
        if (moreBtn) moreBtn.hidden = true;
      } else {
        applyReveal();
      }
      var none = document.getElementById('ReviewNone');
      if (none) none.hidden = matches !== 0;
    });
  }
}());

